module.exports = __webpack_public_path__ + "img/PM.c69d76ae.png";